import React, { Component, useCallback, useState } from 'react';
// import privacyPublic from './resources/Privacy/Public.png';
// import privacyPrivate from './resources/Privacy/Private.png';

import lengthNormal from './resources/Length/Normal.png';
import lengthLong from './resources/Length/Long.png';

import carsAmountLow from './resources/Cars/Low.png';
import carsAmountUsual from './resources/Cars/Usual.png';
import carsAmountIntense from './resources/Cars/Intense.png';

import curvesTwisty from './resources/Curves/Twisty.png';
import curvesStraight from './resources/Curves/Straight.png';

import mapBigApple from './resources/Map/BigApple.png';
import mapDegenRaceway from './resources/Map/DegenRaceway.png';
import mapMiamiBeach from './resources/Map/MiamiBeach.png';
import mapStacksPlaza from './resources/Map/StacksPlaza.png';

import backgroundMapCreator from './resources/BG.png';
import { MapsTemp } from '../../game-engine/maps-utils/map-functions-temp';
import { link_comp } from '../../game-engine/maps-utils/constants';

export interface CreateLobbySuciuProps {
  accountAddress: string;
  accountAddressShort: string;
  customGameProps: CustomMapProps;
  onChangeCustomGameProps: (updateGameProps: CustomMapProps) => void;
}

interface IImageOption {
  source: string;
  title: string;
}

const mapOptions: Record<MapsTemp, IImageOption> = {
  bigApple: {
    source: mapBigApple,
    title: 'BigApple',
  },
  degenRaceway: {
    source: mapDegenRaceway,
    title: 'DegenRaceway',
  },
  miamiBeach: {
    source: mapMiamiBeach,
    title: 'MiamiBeach',
  },
  stackPlaza: {
    source: mapStacksPlaza,
    title: 'StacksPlaza',
  },
};

// export type PrivacyOptions = 'public' | 'private';
// const privacyOptions: Record<PrivacyOptions, IImageOption> = {
//   public: { title: 'Public', source: privacyPublic },
//   private: { title: 'Private', source: privacyPrivate },
// };

export type ILengthOptions = 'normal' | 'long';
const lengthOptions: Record<ILengthOptions, IImageOption> = {
  normal: { title: 'Normal', source: lengthNormal },
  long: { title: 'Long', source: lengthLong },
};

export type TrafficOptions = 'low' | 'usual' | 'intense';
const trafficOptions: Record<TrafficOptions, IImageOption> = {
  low: { title: 'Low', source: carsAmountLow },
  usual: { title: 'Usual', source: carsAmountUsual },
  intense: { title: 'Intense', source: carsAmountIntense },
};

export type CurvesOptions = 'twisty' | 'straight';
const curvesOptions: Record<CurvesOptions, IImageOption> = {
  straight: { title: 'Straight', source: curvesStraight },
  twisty: { title: 'Twisty', source: curvesTwisty },
};

export interface CustomMapProps {
  map: MapsTemp;
  length: ILengthOptions;
  traffic: TrafficOptions;
  curves: CurvesOptions;
  price: number;
  hours: number;
  // privacy: PrivacyOptions;
  description: string;
  cars: number;
  road: Array<number>;
}

export const CreateLobbyComponent = (props: CreateLobbySuciuProps) => {
  const { accountAddress, accountAddressShort, customGameProps, onChangeCustomGameProps } = props;

  const onChangeMapOption = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, map: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  const onChangeLengthOption = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, length: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  const onChangeTrafficOption = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, traffic: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  const onChangeCurvesOption = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, curves: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  // const onChangePrivacyOption = useCallback(
  //   (event) => onChangeCustomGameProps({ ...customGameProps, privacy: event.target.value }),
  //   [onChangeCustomGameProps, customGameProps]
  // );

  const onChangeDescription = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, description: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  const onChangePrice = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, price: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  const onChangeHours = useCallback(
    (event) => onChangeCustomGameProps({ ...customGameProps, hours: event.target.value }),
    [onChangeCustomGameProps, customGameProps]
  );

  return (
    <div className="create-lobby-container">
      <div className="row justify-content-md-center">
        <div className="col-12 col-lg-6 imgHolder">
          <div id="imageCreator">
            <img src={backgroundMapCreator} alt="" className="backgroundLobbyCreation" />
            <img src={backgroundMapCreator} alt="" className="carNone" />
            <img src={mapOptions[customGameProps.map].source} alt="" className="mapLobby" id="mapLobby" />
            <img src={trafficOptions[customGameProps.traffic].source} className="carAmountLobby" id="carAmountLobby" />
            <img src={lengthOptions[customGameProps.length].source} alt="" className="lengthLobby" id="lengthLobby" />
            <img src={curvesOptions[customGameProps.curves].source} alt="" className="curvesLobby" id="curvesLobby" />
            {/* <img
              src={privacyOptions[customGameProps.privacy].source}
              alt=""
              className="privacyLobby"
              id="privacyLobby"
            /> */}
          </div>
        </div>

        <div className="col-12 col-lg-6">
          {/* commission - 10%, factor - 3  */}
          <label htmlFor="map-select"> Map </label>
          <br />

          <select
            name="map-select"
            id="map-select"
            required
            style={{ padding: '10px' }}
            onChange={onChangeMapOption}
            value={customGameProps.map}
          >
            {Object.entries(mapOptions).map((mapEntry) => (
              <option key={mapEntry[0]} value={mapEntry[0]}>
                {mapEntry[1].title}
              </option>
            ))}
          </select>
          <br />
          {/* <label htmlFor="privacy-select">Privacy</label>
          <br />
          <select
            name="privacy-select"
            id="privacy-select"
            required
            style={{ padding: '10px' }}
            onChange={onChangePrivacyOption}
            value={customGameProps.privacy}
          >
            {Object.entries(privacyOptions).map((privacyEntry) => (
              <option key={privacyEntry[0]} value={privacyEntry[0]}>
                {privacyEntry[1].title}
              </option>
            ))}
          </select>
          <br /> */}
          <label htmlFor="length-select">Length</label>
          <br />
          <select
            name="length-select"
            id="length-select"
            required
            style={{ padding: '10px' }}
            onChange={onChangeLengthOption}
            value={customGameProps.length}
          >
            {Object.entries(lengthOptions).map((lengthEntry) => (
              <option key={lengthEntry[0]} value={lengthEntry[0]}>
                {lengthEntry[1].title}
              </option>
            ))}
          </select>
          <br />
          <label htmlFor="traffic-select">Traffic</label>
          <br />
          <select
            name="traffic-select"
            id="traffic-select"
            required
            style={{ padding: '10px' }}
            onChange={onChangeTrafficOption}
            value={customGameProps.traffic}
          >
            {Object.entries(trafficOptions).map((trafficEntry) => (
              <option key={trafficEntry[0]} value={trafficEntry[0]}>
                {trafficEntry[1].title}
              </option>
            ))}
          </select>
          <br />
          <label htmlFor="curves-select"> Curves</label>
          <br />
          <select
            name="curves-select"
            id="curves-select"
            required
            style={{ padding: '10px' }}
            value={customGameProps.curves}
            onChange={onChangeCurvesOption}
          >
            {Object.entries(curvesOptions).map((curveEntry) => (
              <option key={curveEntry[0]} value={curveEntry[0]}>
                {curveEntry[1].title}
              </option>
            ))}
          </select>
          <br />
          <label htmlFor="price-lobby">Price STX ( max 5 )</label>
          <br />
          <input
            type="number"
            min="1"
            max="5"
            value={customGameProps.price}
            id="price-lobby"
            name="price-lobby"
            onChange={onChangePrice}
          />
          <br />
          <label htmlFor="hours-lobby">Hours ( max 48 )</label>
          <br />
          <input
            type="number"
            min="1"
            max="48"
            step="1"
            value={customGameProps.hours}
            id="hours-lobby"
            name="hours-lobby"
            onChange={onChangeHours}
          />
          <br />
          <label htmlFor="description-lobby">Description</label>
          <br />
          <input
            type="text"
            maxLength={98}
            value={customGameProps.description}
            id="description-lobby"
            name="description-lobby"
            onChange={onChangeDescription}
          />
          <br />
        </div>
        <div className="col-12 col-md-4">
          <br />
        </div>
      </div>
    </div>
  );
};
